<div *ngIf="selectedBookingRequest">
    <p-toast></p-toast>
    <p-dialog [modal]="true" [(visible)]="displayRequests" header="Select lead">
        <div class="lead-list-container">
            <p-button label="Select" (onClick)="selectLead()"></p-button>
            <p-listbox [filter]="true" [options]="contactRequests" [(ngModel)]="selectedContactRequest"
                [style]="{'width':'420px'}"></p-listbox>
        </div>
    </p-dialog>
    <p-dialog [modal]="true" header="Select destination" [(visible)]="showDestinationDialog">
        <div *ngIf="schoolWithDetail">
            This school has multiple destinations. Please select one:
            <div *ngFor="let country of schoolWithDetail.countryList" class="line-item">
                <div class="line-item-left-box">
                    {{country.name}}
                </div>
                <div>
                    <p-button icon="pi pi-check" (onClick)="selectDestination(country)"></p-button>
                </div>
            </div>
        </div>
    </p-dialog>
    <p-dialog [modal]="true" header="Select programme type" [(visible)]="showProgrammeTypeDialog">
        <div *ngIf="schoolWithDetail">
            This school has multiple programme types. Please select one:
            <div *ngFor="let programmeType of schoolWithDetail.programmeTypes" class="line-item">
                <div class="line-item-left-box">
                    {{programmeType.name}}
                </div>
                <div>
                    <p-button icon="pi pi-check" (onClick)="selectProgrammeType(programmeType)"></p-button>
                </div>
            </div>
        </div>
    </p-dialog>
    <p-dialog [modal]="true" [(visible)]="editComment">
        <div class="comment-edit-container">
            <textarea pInputTextarea cols="52" rows="10" [(ngModel)]="newCommentStr"></textarea>
            <div class="save-cancel-button-container">
                <p-button label="Save" (onClick)="updateComment()"></p-button>
            </div>
        </div>
    </p-dialog>
    <p-dialog [modal]="true" [(visible)]="showAccommodationTypeDialog" *ngIf="requestToApprove">
        <div class="accommodation-type-dialog">
            <p>{{requestToApprove.accommodationType}} is not a valid accommodation type. Please select</p>
            <div class="type-button-container">
                <p-dropdown placeholder="SELECT" [options]="accommodationTypes" optionLabel="name"
                    [(ngModel)]="newAccommodationType"></p-dropdown>
                <p-button label="OK" (onClick)="updateAccommodationType()"></p-button>
            </div>
        </div>
    </p-dialog>
    <p-dialog [modal]="true" [(visible)]="showRoomTypeDialog" *ngIf="requestToApprove">
        <div class="accommodation-type-dialog">
            <p>{{requestToApprove.roomType}} is not a valid room type. Please select</p>
            <div class="type-button-container">
                <p-dropdown placeholder="SELECT" [options]="roomTypes" optionLabel="name" [(ngModel)]="newRoomType">
                </p-dropdown>
                <p-button label="OK" (onClick)="updateRoomType()"></p-button>
            </div>
        </div>
    </p-dialog>
    <p-dialog [modal]="true" [(visible)]="showBoardTypeDialog" *ngIf="requestToApprove">
        <div class="accommodation-type-dialog">
            <p>{{requestToApprove.board}} is not a valid board type. Please select</p>
            <div class="type-button-container">
                <p-dropdown placeholder="SELECT" [options]="boardTypes" optionLabel="name" [(ngModel)]="newBoardType">
                </p-dropdown>
                <p-button label="OK" (onClick)="updateBoardType()"></p-button>
            </div>
        </div>
    </p-dialog>
    <p-dialog [modal]="true" [(visible)]="isEmailDialogActive" header=" Send email to: {{selectedBookingRequest!.email}}">
        <div [formGroup]="emailForm!" class="email-form">
            <p>Subject:</p>
            <input pInputText formControlName="subject" [style]="{'width':'100%'}">
            <ckeditor [editor]="Editor" formControlName="body"></ckeditor> 
            <p-button label="Send" (onClick)="sendEmail()"></p-button>
            <div *ngIf="isSendingEmail">
                <p-progressSpinner></p-progressSpinner>
                <div>Sending...</div>
            </div>
            <div>
                <span>
                    Signature:
                </span>
                <p-dropdown placeholder="Signature" formControlName="signature" appendTo="body" 
                    [options]="emailSignatureService.emailSignatures" optionLabel="language.name"></p-dropdown>
            </div>
            <div>
                Paste Pixel
                <p-checkbox [binary]="true" formControlName="hasPastePixel"></p-checkbox>
            </div>
        </div>
   </p-dialog>
    <p-dialog [modal]="true" [(visible)]="displayMailHistoryDetail"
        header="Details of email sent #{{selectedEmailHistory.id!}}" *ngIf="selectedEmailHistory">
        <div class="email-history-container">
            <div class="email-line-item">
                <span class="email-item">Mail sent by </span>
                <span><strong>{{selectedEmailHistory.sentBy.name}}</strong></span>
                <span class="email-item"> on </span>
                <span>
                    <strong>
                        {{selectedEmailHistory.sentDateTime?.toDate() | date:'dd/MM/yyyy - HH:mm'}}
                    </strong>
                </span>
            </div>
            <div class="email-line-item">
                <span class="email-item">
                    Subject:
                </span>
                <span>
                    <strong>
                        {{selectedEmailHistory.subject}}
                    </strong>
                </span>
            </div>
            <div class="email-message-section-container">
                <p class="email-item">
                    Message:
                </p>
                <div [innerHTML]="selectedEmailHistory.body" class="sent-email-message-container"></div>
                <div
                    *ngIf="selectedEmailHistory.attachmentFileNames && selectedEmailHistory.attachmentFileNames.length > 0">
                    <p class="email-item">
                        Attachment:
                    </p>
                    <p *ngFor="let fileName of selectedEmailHistory.attachmentFileNames">
                        {{fileName}}
                    </p>
                </div>
            </div>
        </div>
    </p-dialog>
    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
    <div class="main-container">
        <div class="left-container">
            <h3 class="global-title">
                Booking Request
            </h3>
            <p-table [value]="requestData">
                <ng-template pTemplate="header">
                    <th [style]="{width: '170px'}"></th>
                    <th></th>
                </ng-template>
                <ng-template pTemplate="body" let-request>
                    <tr>
                        <td>Name</td>
                        <td>{{request.firstName}} {{request.familyName}}</td>
                    </tr>
                    <tr>
                        <td>
                            Age
                        </td>
                        <td>
                            {{request.age}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Nationality
                        </td>
                        <td>
                            {{request.nationality}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Nationality2
                        </td>
                        <td>
                            {{request.otherNationality}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Language
                        </td>
                        <td>
                            {{request.firstLanguage}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Phone
                        </td>
                        <td>
                            {{request.phoneNumber}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Email
                        </td>
                        <td>
                            {{request.email}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            City
                        </td>
                        <td>
                            {{request.city}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Country
                        </td>
                        <td>
                            {{request.country}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Country2
                        </td>
                        <td>
                            {{request.otherCountry}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Programme
                        </td>
                        <td>
                            {{request.programme}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Lessons per week
                        </td>
                        <td>
                            {{request.lessonsPerWeek}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Programme Option
                        </td>
                        <td>
                            {{request.programmeOption}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            From
                        </td>
                        <td>
                            {{request.startDay | date:"dd/MM/yyyy"}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            To
                        </td>
                        <td>
                            {{request.endDay | date:"dd/MM/yyyy"}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Accommodation Type
                        </td>
                        <td>
                            {{request.accommodationType}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Room Type
                        </td>
                        <td>
                            {{request.roomType}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Board
                        </td>
                        <td>
                            {{request.board}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Non smoking family
                        </td>
                        <td>
                            {{request.nonSmokingFamily}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Family with no kids
                        </td>
                        <td>
                            {{request.familyWithNoKids}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Family with no pets
                        </td>
                        <td>
                            {{request.familyWithNopets}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Allergy or medical issues
                        </td>
                        <td>
                            {{request.allergyOrMedicalIssues}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Accommodation preference
                        </td>
                        <td>
                            {{request.accommodationPreference}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Phone number
                        </td>
                        <td>{{request.phoneNumber}}</td>
                    </tr>
                    <tr>
                        <td>
                            Mobile number
                        </td>
                        <td>
                            {{request.mobileNumber}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Gender
                        </td>
                        <td>
                            {{request.gender}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Birth Place
                        </td>
                        <td>
                            {{request.birthPlace}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Birth date
                        </td>
                        <td>
                            {{request.birthDate | date:"dd/MM/yyyy"}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Language Level
                        </td>
                        <td>
                            {{request.targetLanguageLevel}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Difficulty for learning
                        </td>
                        <td>
                            {{request.learningDifficulty}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Street
                        </td>
                        <td>
                            {{request.street}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Additional address
                        </td>
                        <td>
                            {{request.additionalAddress}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Emergency contact
                        </td>
                        <td>
                            {{request.emergencyContactName}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Relationship to student
                        </td>
                        <td>
                            {{request.emergencyContactType?.name}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Emergency email
                        </td>
                        <td>
                            {{request.emergencyContactEmail}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Emergency phone
                        </td>
                        <td>
                            {{request.emergencyContactPhone}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Parent name
                        </td>
                        <td>
                            {{request.parentName}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Parent profession
                        </td>
                        <td>
                            {{request.parentProfession}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Parent email
                        </td>
                        <td>
                            {{request.parentEmail}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Parent phone
                        </td>
                        <td>
                            {{request.parentPhone}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Travel with LVI
                        </td>
                        <td>
                            {{request.travelWithLvi}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Airport transfer type
                        </td>
                        <td>
                            {{request.airportTransferType}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Cancellation Guarantee
                        </td>
                        <td>
                            {{request.needCancellationGuarantee}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Medical Insurance
                        </td>
                        <td>
                            {{request.needMedicalInsurance}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Promotion Code
                        </td>
                        <td>
                            {{request.promotionCode}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Source of information
                        </td>
                        <td>
                            {{request.informationSource}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Source information detail
                        </td>
                        <td>
                            {{request.informationSourceDetail}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Comment
                        </td>
                        <td>
                            {{request.comment}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Created
                        </td>
                        <td>
                            {{request.created | date:"dd/MM/yyyy HH:mm:ss"}}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="right-container">
            <div *ngIf="suggestedSchools.length > 0">
                <p class="global-title">
                    Schools found by programme name:
                </p>
                <div *ngFor="let school of suggestedSchools; let i = index" class="school-name-button-container">
                    <div>
                        {{i+1}}: {{school.name}}
                    </div>
                    <div>
                        <p-button icon="pi pi-check" (onClick)="setSelectedSchoolById(school.id!)"></p-button>
                    </div>
                </div>
            </div>
            <div class="modification-container">
                <div>
                    <p>
                        *School
                    </p>
                    <p-dropdown [filter]="true" filterBy="name" placeholder="Select school" [options]="schoolList" optionLabel="name"
                        dataKey="id" [(ngModel)]="selectedBookingRequest.lviSchool" (onChange)="updateRequest();loadLanguageCourseList($event.value)">
                    </p-dropdown>
                </div>
                <div>
                    <p>
                        *Course
                    </p>
                    <p-dropdown placeholder="Select course" [options]="languageCourseList" optionLabel="code" 
                    [(ngModel)]="selectedBookingRequest.languageCourse" (onChange)="updateRequest()"></p-dropdown>
                </div>
                <div>
                    <p>
                        *Agent
                    </p>
                    <p-dropdown placeholder="Select agent" [options]="agentList" optionLabel="name"
                        [(ngModel)]="selectedBookingRequest.agent" (onChange)="updateRequest()"></p-dropdown>
                </div>
            </div>
            <div class="action-button-container">
                <p-button (onClick)="openEmailDialog()" label="Send Email" [style]="{width: '100%'}"></p-button>
                <p-button (onClick)="goToPrintPage()" label="Print" [style]="{width: '100%'}"></p-button>
                <p-button (onClick)="approveBookingRequest()" label="Approve for Booking"
                    styleClass="p-button-success" [style]="{width: '100%'}"></p-button>
                <p-button (onClick)="deleteRequest()" label="Delete this request" styleClass="p-button-danger" [style]="{width: '100%'}">
                </p-button>
                <p-button label="Connect a lead" (onClick)="activateLeadSelector()" [style]="{width: '100%'}"></p-button>
            </div>
            <div class="new-comment-form">
                <h3 class="global-title">
                    Comment
                </h3>
                <textarea pInputTextarea cols="32" rows="10" [(ngModel)]="newCommentBody"></textarea>
                <p-button label="Post" (onClick)="postNewComment()"></p-button>
            </div>
            <div class="old-comments-container">
                <div *ngFor="let comment of bookingRequestComments">
                    <div class="comment-body-container">
                        <p class="comment-body">
                            {{comment.body}}
                        </p>
                    </div>
                    <div class="comment-footer">
                        <span>
                            {{comment.createdBy!.name}} on {{comment.created!.toDate() | date:"dd/MM/yyyy HH:mm"}}
                        </span>
                        <span *ngIf="comment.createdBy!.name==userService.userName">
                            <a (click)="activateCommentEditDialog(comment)">
                                Edit
                            </a> -
                            <a (click)="deleteComment(comment)">Delete</a>
                        </span>
                    </div>
                </div>
            </div>
            <div>
                <h4>Emails sent</h4>
                <div class="email-history-container">
                    <p-card *ngFor="let email of sentEmails">
                        <p>
                            Mail Sent - {{email.sentDateTime?.toDate() | date:'dd/MM/yyyy - HH:mm'}}
                        </p>
                        <p>
                            Sent by: {{email.sentBy.name}}
                        </p>
                        <p-button label="VIEW E-MAIL" (onClick)="activateEmailHistoryDetail(email)"></p-button>
                        <div *ngIf="email.isOpened" class="tag-item">
                            Seen on: {{email.openedAt?.toDate() | date:'dd/MM/yyyy - HH:mm'}}
                        </div>
                    </p-card>
                </div>
            </div>
        </div>
    </div>
</div>